<template>
  <b-card class="mb-2">
    <b-row class="align-items-end">
      <b-col cols="12" md="4" lg="3">
        <b-form-group label="Date range" label-for="dashboard-date-range-preset">
          <b-form-select
            id="dashboard-date-range-preset"
            v-model="dateRangePreset"
            :options="dateRangePresetOptions"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="dateRangePreset === 'custom'" cols="12" md="4" lg="3">
        <b-form-group label="From" label-for="dashboard-custom-date-from">
          <b-form-datepicker
            id="dashboard-custom-date-from"
            v-model="customDateFrom"
            locale="en"
            :date-format-options="dateFormatOptions"
            :max="customDateTo || undefined"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="dateRangePreset === 'custom'" cols="12" md="4" lg="3">
        <b-form-group label="To" label-for="dashboard-custom-date-to">
          <b-form-datepicker
            id="dashboard-custom-date-to"
            v-model="customDateTo"
            locale="en"
            :date-format-options="dateFormatOptions"
            :min="customDateFrom || undefined"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="$scopedSlots.filters || $slots.filters" cols="12" md="4" lg="3">
        <slot name="filters" />
      </b-col>

      <b-col cols="12" md="4" lg="3" class="mb-1">
        <slot
          name="summary"
          :date-range="selectedDateRange"
          :formatted-date-range="formattedDateRange"
        >
          <div class="text-muted small">
            {{ formattedDateRange }}
          </div>
        </slot>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BCol, BFormDatepicker, BFormGroup, BFormSelect, BRow } from 'bootstrap-vue'
import {
  DATE_RANGE_PRESETS,
  DASHBOARD_DATE_RANGE_PRESET_OPTIONS,
  formatDashboardDateRange,
  resolveDashboardDateRange,
} from '@/libs/dashboardDateRange'
import { moment, companyTz } from '@/libs/companyTime'
import { FORM_DATEPICKER_FORMAT_OPTIONS } from '@/constants/enums'

export { DATE_RANGE_PRESETS, resolveDashboardDateRange }

export default {
  components: {
    BCard,
    BCol,
    BFormDatepicker,
    BFormGroup,
    BFormSelect,
    BRow,
  },
  props: {
    defaultPreset: {
      type: String,
      default: DATE_RANGE_PRESETS.this_month,
    },
  },
  data() {
    return {
      dateRangePreset: this.defaultPreset,
      customDateFrom: null,
      customDateTo: null,
      dateRangePresetOptions: DASHBOARD_DATE_RANGE_PRESET_OPTIONS,
      dateFormatOptions: FORM_DATEPICKER_FORMAT_OPTIONS,
    }
  },
  computed: {
    selectedDateRange() {
      return resolveDashboardDateRange(
        this.dateRangePreset,
        this.customDateFrom,
        this.customDateTo,
      )
    },
    formattedDateRange() {
      return formatDashboardDateRange(this.selectedDateRange)
    },
  },
  watch: {
    dateRangePreset() {
      this.handleRangeUpdate()
    },
    customDateFrom() {
      if (this.dateRangePreset === DATE_RANGE_PRESETS.custom) {
        this.handleRangeUpdate()
      }
    },
    customDateTo() {
      if (this.dateRangePreset === DATE_RANGE_PRESETS.custom) {
        this.handleRangeUpdate()
      }
    },
  },
  mounted() {
    this.handleRangeUpdate()
  },
  methods: {
    handleRangeUpdate() {
      if (this.dateRangePreset === DATE_RANGE_PRESETS.custom) {
        if (!this.customDateFrom || !this.customDateTo) {
          const today = moment.tz(companyTz())
          if (!this.customDateFrom) {
            this.customDateFrom = today.clone().startOf('month').format('YYYY-MM-DD')
          }
          if (!this.customDateTo) {
            this.customDateTo = today.format('YYYY-MM-DD')
          }
          return
        }
      }

      this.$nextTick(() => {
        this.emitChange()
      })
    },
    emitChange() {
      const { from, to } = this.selectedDateRange

      if (!from || !to) {
        return
      }

      this.$emit('change', {
        from,
        to,
        preset: this.dateRangePreset,
      })
    },
  },
}
</script>
